import { mapActions } from "vuex";

export default {
    created() {

    },
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async actualizarFtn() {
            try {

            } catch {

            }
        },
        async saveForm(event) {
            try {
                let savePost = false
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'anularRegistroFtn':
                            if (this.dataForm[this.namePath].info_aportes.servicios != 2) {
                                const await0 = this.updateDataPost({ state: 'tablaPost', data: ['info_aportes', 'aportes_registro', 'archivo_plano', 'servicios_activos', 'info_afiliacion'] })
                                const await1 = this.updateDataPost({ state: 'tablaDelete', data: ['info_aportes', 'aportes_registro', 'archivo_plano'] })
                                const await2 = this.updateDataPost({ state: 'route', data: 'save_all' })
                                const await3 = this.updateDataPost({ state: 'tablaAuditar', data: true })
                                const await4 = this.updateDataPost({ state: 'notaDelete', data: this.dataForm[this.namePath].info_aportes.nota_delete })

                                await Promise.all([await0, await1, await2, await3, await4])

                                savePost = true

                            } else {
                                const await0 = this.updateDataPost({ state: 'tablaPost', data: ['info_aportes'] })
                                const await1 = this.updateDataPost({ state: 'tablaDelete', data: ['info_aportes'] })
                                const await2 = this.updateDataPost({ state: 'route', data: 'save_all' })
                                const await3 = this.updateDataPost({ state: 'tablaAuditar', data: true })
                                const await4 = this.updateDataPost({ state: 'notaDelete', data: this.dataForm[this.namePath].info_aportes.nota_delete })

                                await Promise.all([await0, await1, await2, await3, await4])

                                savePost = true
                            }

                            break;
                        case 'descargarAflFtn':
                            if (this.dataForm[this.namePath].info_aportes.servicios != 2) {
                                if (this.dataForm[this.namePath].info_aportes.tipo === 0) {
                                    if (this.dataForm[this.namePath].info_afiliacion.id_datos_razon === this.dataForm[this.namePath].archivo_plano.id_datos_razon) {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                route: 'save_all',
                                                tablaAuditar: true,
                                                notaDelete: null,
                                                tablaPost: ['info_aportes', 'info_afiliacion', 'archivo_plano', 'aportes_registro', 'servicios_activos'],
                                                tablaDelete: []
                                            }
                                        })
                                    } else {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                route: 'save_all',
                                                tablaAuditar: true,
                                                notaDelete: null,
                                                tablaPost: ['info_aportes', 'archivo_plano', 'aportes_registro'],
                                                tablaDelete: []
                                            }
                                        })
                                    }

                                }
                                if (this.dataForm[this.namePath].info_aportes.tipo === 1) {
                                    await this.updateDataPost({ state: 'tablaPost', data: ['info_aportes', 'info_afiliacion', 'archivo_plano', 'aportes_registro', 'servicios_activos'] })
                                    await this.updateDataPost({ state: 'tablaDelete', data: [] })
                                    await this.updateDataPost({ state: 'route', data: 'save_all' })
                                    await this.updateDataPost({ state: 'notaDelete', data: null })

                                    savePost = true
                                }

                            } else {
                                await this.updateDataPost({
                                    data: {
                                        data: [],
                                        route: 'save_all',
                                        tablaAuditar: true,
                                        notaDelete: null,
                                        tablaPost: ['info_aportes'],
                                        tablaDelete: []
                                    }
                                })
                            }

                            break;
                    }
                }

                await this.save(event.save, savePost)

                const await30 = this.getDataGet({ route: 'get_aportesdescargar', data: { others: [] } })
                    // frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
                const await31 = this.resetDataIndex()
                const await32 = this.resetGlobal({ state: 'openModal' })
                const await33 = this.resetDataForm()
                const await34 = this.resetGlobal({ state: 'saveConfig/capa' })

                await Promise.all([await30, await31, await32, await33, await34])
            } catch {

            }
        }
    },
}